(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,7190],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 5075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);





var MainSearchBox = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5445), __webpack_require__.e(2013), __webpack_require__.e(9762)]).then(__webpack_require__.bind(__webpack_require__, 1422));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1422)
            ];
        }
    },
    suspense: true
});
var Featured = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3500).then(__webpack_require__.bind(__webpack_require__, 43500));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43500)
            ];
        }
    },
    suspense: true
});
var Section = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9427), __webpack_require__.e(6376)]).then(__webpack_require__.bind(__webpack_require__, 96376));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96376)
            ];
        }
    }
});
var FeaturedArticles = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3531).then(__webpack_require__.bind(__webpack_require__, 23531));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23531)
            ];
        }
    }
});
var Evaluation = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 4927).then(__webpack_require__.bind(__webpack_require__, 94927));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94927)
            ];
        }
    }
});
var Desc = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 5455).then(__webpack_require__.bind(__webpack_require__, 75455));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75455)
            ];
        }
    }
});
var Home = function(param) {
    var featured = param.featured, blogs = param.blogs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Bungalows for Sale in Ontario visit Bungalow Finder"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        property: "og:title",
                        content: "Bungalows for Sale in Ontario visit Bungalow Finder"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        property: "og:description",
                        content: "how to find bungalows for sale in Canada? Bungalowfinder.ca is real estate website to discover modern bungalows, raised bungalows, at affordable prices. "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "Bungalows for sale, Bungalow Finder, Bungalow for sale,properties for sale,houses to rent,property for sale,link house for sale,new properties for sale,private property rentals,property for sale in canada,cottage house for sale,property for sale deals,bungalow for sale,detached house for sale,duplex house for sale,bungalows for sale,semi detached house for sale,houses for sale in toronto canada,house for rent in mississauga,mississauga rentals,Rentals in Mississauga,rental apartments in mississauga,realtors in mississauga,townhouse for rent mississauga,bungalows for rent in mississauga"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://bungalowfinder.ca"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://bungalowfinder.ca/bungalow-color-logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: "1200"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: "630"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:alt",
                        content: "Bungalows for Sale in Ontario visit Bungalow Finder"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Bungalows for Sale in Ontario visit Bungalow Finder"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "Looking for a Bungalows for Sale in Canada"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://bungalowfinder.ca/images/ogimg.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n            {\n              "@context": "https://schema.org/",\n              "@type": "WebSite",\n              "name": "Bungalow Finder",\n              "url": "https://bungalowfinder.ca/",\n              "sameAs": "https://bungalowfinder.ca/",\n              "description": "Discover your dream bungalow home in Canada with BungalowFinder.ca. Explore our extensive listings and expert resources for a seamless house-hunting experience. Find the perfect single-story living space that suits your preferences and lifestyle. Start your bungalow journey today!",\n              "potentialAction": {\n                "@type": "SearchAction",\n                "target": "https://bungalowfinder.ca/city/{city}",\n                "query-input": "name=city"\n              },\n              "aggregateRating": {\n                "@type": "AggregateRating",\n                "itemReviewed": {\n                  "@type": "LocalBusiness",\n                  "name": "Bungalow Finder",\n                  "address": "33 Pearl Street, Mississauga, On L5M1X1",\n                  "image": "https://bungalowfinder.ca/_next/image?url=%2Fbanner.jpeg&w=3840&q=75",\n                  "aggregateRating": {\n                    "@type": "AggregateRating",\n                    "ratingValue": "4.9",\n                    "ratingCount": "5"\n                  }\n                },\n                "ratingValue": "4.9",\n                "ratingCount": "5"\n              },\n              "sourceOrganization": {\n                "@type": "Organization",\n                "name": "Bungalow Finder"\n              }\n            }'
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n            {\n              "@context": "https://schema.org/",\n              "@type": "ItemList",\n              "itemListElement": [\n                {\n                  "@type": "ListItem",\n                  "position": 1,\n                  "item":\n                  {\n                   "@id": "https://bungalowfinder.ca/",\n                   "name": "Home"\n                   },\n                  "url": "https://bungalowfinder.ca/"\n                },\n                {\n                  "@type": "ListItem",\n                  "position": 2,\n                  "item":\n                  {\n                   "@id": "https://bungalowfinder.ca/city/Toronto",\n                   "name": "Bungalow for sale in Toronto"\n                   },\n                  "url": "https://bungalowfinder.ca/city/Toronto"\n                },\n                {\n                  "@type": "ListItem",\n                  "position": 3,\n                  "item":\n                  {\n                   "@id": "https://bungalowfinder.ca/city/Mississauga",\n                   "name": "BBungalow for sale in Mississauga"\n                   },\n                  "url": "https://bungalowfinder.ca/city/Mississauga"\n                },\n                {\n                  "@type": "ListItem",\n                  "position": 4,\n                  "item":\n                  {\n                   "@id": "https://bungalowfinder.ca/city/Oakville",\n                   "name": "BBungalow for sale in Oakville"\n                   },\n                  "url": "https://bungalowfinder.ca/city/Oakville"\n                },\n                {\n                  "@type": "ListItem",\n                  "position": 5,\n                  "item":\n                  {\n                   "@id": "https://bungalowfinder.ca/city/Milton",\n                   "name": "BBungalow for sale in Milton"\n                   },\n                  "url": "https://bungalowfinder.ca/city/Milton"\n                },\n                {\n                  "@type": "ListItem",\n                  "position": 6,\n                  "item":\n                  {\n                   "@id": "https://bungalowfinder.ca/city/Burlington",\n                   "name": "BBungalow for sale in Burlington"\n                   },\n                  "url": "https://bungalowfinder.ca/city/Burlington"\n                },\n                {\n                  "@type": "ListItem",\n                  "position": 7,\n                  "item":\n                  {\n                   "@id": "https://bungalowfinder.ca/city/Brampton",\n                   "name": "BBungalow for sale in Bramtpon"\n                   },\n                  "url": "https://bungalowfinder.ca/city/Brampton"\n                },\n                {\n                  "@type": "ListItem",\n                  "position":8,\n                  "item":\n                  {\n                   "@id": "https://bungalowfinder.ca/blogs",\n                   "name": "BBungalow Finder Real Estate Blog"\n                   },\n                  "url": "https://bungalowfinder.ca/blogs"\n                }]}'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:h-[75vh] h-[50vh] relative flex z-30 justify-center items-end pb-14 md:items-center md:pb-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                        className: "absolute -z-50 scale-100",
                        src: "/banner.jpeg",
                        priority: true,
                        placeholder: "blur",
                        blurDataURL: "data:image/webp;base64,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",
                        alt: "Banner",
                        layout: "fill",
                        objectFit: "cover"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col justify-center items-center w-full md:w-1/2 z-50 px-3 container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                style: {
                                    textShadow: "0 0 1rem #000"
                                },
                                className: "text-white text-lg md:text-3xl pb-5 font-medium text-center",
                                children: "Discover Bungalows For Sale"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "Loading..."
                                    })
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MainSearchBox, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "Loading..."
                    })
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Featured, {
                    properties: featured
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Evaluation, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Section, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeaturedArticles, {
                articles: blogs
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Desc, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);